import React, { useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import CardHeader from "@mui/material/CardHeader";
import Avatar from "@mui/material/Avatar";
import sohaibavatar from "../../assets/images/dashboard/sohaibavatar.png";
import { Box } from "@mui/material";
import CustomPagination from "../common/CustomPagination";
import prescriptionSVG from "../../assets/images/common/prescription.svg";
import Cross from "../common/Cross";
import Tick from "../common/Tick.js";
import "../../assets/css/common/datatable.scss";

import SampleImg from "../../assets/images/dashboard/SampleImg.png";

const DataTable = ({
  onTickClick,
  onCrossClick,
  rows,
  filterOption,
  searchQuery,
}) => {
  
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (newPage) => {
    setPage(newPage);
  };

  //  Select filter & search filter functionality
  const filteredRows = rows.filter((row) => {
    const date = new Date(row.date);
    const today = new Date();
    if (filterOption === "Today") {
      if (date.toDateString() !== today.toDateString()) {
        return false;
      }
    } else if (filterOption === "Yesterday") {
      const yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);
      if (date.toDateString() !== yesterday.toDateString()) {
        return false;
      }
    } else if (filterOption === "Tomorrow") {
      const tomorrow = new Date(today);
      tomorrow.setDate(today.getDate() + 1);
      if (date.toDateString() !== tomorrow.toDateString()) {
        return false;
      }
    }

    const searchQueryLower = searchQuery.toLowerCase();
    const nameLower = row.name.toLowerCase();
    const civilIDLower = row.civilID.toLowerCase();
    if (
      !nameLower.includes(searchQueryLower) &&
      !civilIDLower.includes(searchQueryLower)
    ) {
      return false;
    }

    return true;
  });


  const totalRows = filteredRows.length;
  const totalPages = Math.ceil(totalRows / rowsPerPage);
  const startIndex = page * rowsPerPage;
  const endIndex = Math.min(startIndex + rowsPerPage, totalRows);
  const visibleRows = filteredRows.slice(startIndex, endIndex);

  return (
    <>
      <TableContainer
        component={Paper}
        sx={{ backgroundColor: "#FFFFFF" }}
        className="custom-scroll"
      >
        <Table aria-label="simple table">
          <TableHead
            sx={{
              "& th": {
                color: "#193F52",
                whiteSpace: "nowrap",
                wordWrap: "break-word",
              },
            }}
          >
            <TableRow>
              <TableCell className="number" align="left">
                #
              </TableCell>
              <TableCell align="left">Name</TableCell>
              <TableCell align="left">Email</TableCell>
              <TableCell align="left">Age</TableCell>
              <TableCell align="left">Gender</TableCell>
              <TableCell align="left">Specialization</TableCell>
              <TableCell align="left">Date</TableCell>
              <TableCell align="left">Time</TableCell>
              <TableCell align="left">Civil ID</TableCell>
              <TableCell align="left">Doctor</TableCell>
              <TableCell align="left">Fees</TableCell>
              <TableCell align="center">Appointment Status</TableCell>
              <TableCell align="center">Prescription</TableCell>
            </TableRow>
          </TableHead>

          <TableBody
            sx={{
              "& td": {
                color: "#767676",
                whiteSpace: "nowrap",
                wordWrap: "break-word",
              },
            }}
          >
            {visibleRows.map((row, index) => (
              <TableRow
                key={index}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell align="left" className="number">
                  {row.number}
                </TableCell>
                <TableCell align="left">
                  <CardHeader
                    sx={{ padding: "0px" }}
                    avatar={
                      <Box
                        sx={{
                          filter: "drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.1))",
                        }}
                      >
                        <Avatar alt="sohaib" src={SampleImg} />
                      </Box>
                    }
                    title={row.name}
                  />
                </TableCell>
                <TableCell align="left">{row.email}</TableCell>
                <TableCell align="left">{row.age}</TableCell>
                <TableCell align="left">{row.gender}</TableCell>
                <TableCell align="left">{row.specialization}</TableCell>
                <TableCell align="left">{row.date}</TableCell>
                <TableCell align="left">{row.time}</TableCell>
                <TableCell align="left">{row.civilID}</TableCell>
                <TableCell align="left">
                  <CardHeader
                    sx={{ padding: "0px" }}
                    avatar={
                      <Box
                        sx={{
                          filter: "drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.1))",
                        }}
                      >
                        <Avatar alt="sohaib" src={SampleImg} />
                      </Box>
                    } 
                    title={row.doctor}
                  />
                </TableCell>
                <TableCell align="left">{row.fees}</TableCell>
                <TableCell>
                  {row.appointmentStatus === "Approved" ? (
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Box className="approved-btn">Approved</Box>
                    </Box>
                  ) : row.appointmentStatus === "Not Approved" ? (
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Box className="not-approved-btn">Not Approved</Box>
                    </Box>
                  ) : (
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "0.2rem",
                      }}
                    >
                      <Tick onTick={onTickClick} />
                      <Cross onCross={onCrossClick} />
                    </Box>
                  )}
                </TableCell>

                <TableCell align="center">
                  <img src={prescriptionSVG} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <div className="pagination-container">
        <div className="pagination-detail">
          Showing {page * rowsPerPage + 1} -{" "}
          {Math.min((page + 1) * rowsPerPage, filteredRows.length)} of {rows.length}
        </div>
        <CustomPagination
          page={page}
          totalPages={totalPages}
          onChangePage={handleChangePage}
        />
      </div>
    </>
  );
};

export default DataTable;
